import React from 'react'
import queryString from 'query-string'
import CheckContainer from './CheckContainer'
import CheckPageHome from './CheckPageHome'

class CheckPage extends React.Component {
    state = {
        id: null
    }

    text = ''
    timeoutClearText = null

    onKeyPress = (e) => {
        const {key} = e
        const text1 = this.text.replace('Shift3', '#')
        const text2 = text1.replace('Shift-', '_')

        if (key === 'Enter') this.handleChangeId(text2)

        this.text += key

        clearTimeout(this.timeoutClearText)

        this.timeoutClearText = setTimeout(() => (this.text = ''), 100)
    }

    componentDidMount() {
        this.loadStateFromLocation()
        document.addEventListener('keypress', this.onKeyPress)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.loadStateFromLocation()
    }

    componentWillUnmount() {
        document.removeEventListener('keypress', this.onKeyPress)
    }

    handleChangeId = (id) => {
        const {history} = this.props
        const stringified = queryString.stringify({id})
    
        history.push({search: '?' + stringified})
    }

    loadStateFromLocation = async () => {
        const {history: {location: {search}}} = this.props
        const {id} = queryString.parse(search)

        if (id !== this.state.id) {
            return await new Promise(resolve => this.setState({ id }, resolve))
        }
    }

    render() {
        const {id} = this.state

        return (
            <div className='CheckPage'>
                {id ? <CheckContainer id={id} onChangeId={this.handleChangeId} /> : <CheckPageHome onChangeId={this.handleChangeId} />}
            </div>
        )
    }
}

export default CheckPage
